import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { AudioPlayerProvider, useAudioPlayer } from "../context/AudioPlayerContext";

// The sound engine (wavesurfer) is heavy: it loads only on the messenger pages or once something plays.
const Engine = dynamic(() => import("./GlobalAudioPlayerEngine"), { ssr: false });
const VideoFloat = dynamic(() => import("./GlobalVideoNoteFloat"), { ssr: false });
const MiniBar = dynamic(() => import("./GlobalAudioMiniBar"), { ssr: false });

function Inner() {
  const { nowPlaying, floatingVideo } = useAudioPlayer() || {};
  const { pathname } = useRouter();
  const onMessenger = pathname.startsWith("/_/");
  const hasTrack = !!nowPlaying?.url;
  const [engineMounted, setEngineMounted] = useState(false);

  useEffect(() => {
    if (onMessenger || hasTrack) setEngineMounted(true);
  }, [onMessenger, hasTrack]);

  return (
    <>
      {engineMounted ? <Engine /> : null}
      {hasTrack && !onMessenger ? <MiniBar /> : null}
      {floatingVideo ? <VideoFloat /> : null}
    </>
  );
}

/**
 * The messenger's player lives above every page of the site, so a voice or video message
 * keeps playing while the user moves anywhere; outside the messenger a small bar shows it.
 */
export default function GlobalAudioHost({ children }) {
  return (
    <AudioPlayerProvider>
      {children}
      <Inner />
    </AudioPlayerProvider>
  );
}
